export const FAMILY_SITUATIONS = [
  "MARRIED",
  "COHABITING",
  "SEPARATED",
  "DIVORCED",
  "SINGLE_PARENT",
  "WIDOWED",
  "OTHER",
];

export const FAMILY_SITUATION_DEFAULTS = {
  MARRIED: "Married",
  COHABITING: "Cohabiting",
  SEPARATED: "Separated",
  DIVORCED: "Divorced",
  SINGLE_PARENT: "Single parent",
  WIDOWED: "Widowed",
  OTHER: "Other",
};

export const familySituationLabel = (t, value) =>
  t(`family.situation.options.${value || "MARRIED"}`, {
    defaultValue: FAMILY_SITUATION_DEFAULTS[value] || FAMILY_SITUATION_DEFAULTS.MARRIED,
  });

export const hasSeparateHouseholds = (value) => ["SEPARATED", "DIVORCED"].includes(value);
